import { Route } from 'routes/types/Route'

import { StatisticsPage } from './pages'

const routes: Route[] = [{ path: '/admin/statistics/:ownerId?', component: StatisticsPage, layout: 'admin' }]

export default routes
